// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bf","header":"bh","copy":"bi","formLabel":"bj","dismissModal":"bk","buttonRow":"bl","buttonWrapper":"bm","button":"bn"};